(function(){
    angular
        .module('appback')
        .directive('ngProteinatotal', proteinatotalNG);

        proteinatotalNG.$inject = ['$timeout','ResultadosService'];
        function proteinatotalNG($timeout,ResultadosService){
            return {
	            require: 'ngModel',
              	//templateUrl: '/backend/web/app/resultados/operacionmat.html',
	            scope: {
                  ngModel : '=',
                  item: '=',
                  subanalitica: '='
              	},
	            link: function(scope, element, attrs, ngModel) {
	            	return $timeout(function(){
	            		//console.log("itemPROTT",scope.item);
		            		ResultadosService.getProteinaTotal(scope.item.peticion_id,function(data){
		            			if(typeof(scope.subanalitica)!='undefined'){
			            			scope.subanalitica.dilucion = data.dilucion;
			            		}
		            			if((!ngModel.$viewValue ||ngModel.$viewValue=='' || ngModel.$viewValue==0)){
			            			if(data.resultado){
			            				ngModel.$setViewValue(data.resultado);
		                				ngModel.$render();
				            		}
		            			}
				            });

	            	})
	            	
			      /*ngModel.$formatters.push(function(value) {
	            	console.log("tocecimal2");
			      	    return value ? parseFloat(value).toFixed(2).toString().replace(',', '.') : null;
			      });*/
				}
        	}
        }
})();